
/**
 * 国际电话区号
 */
const PHONE_CODE_CN = {
  86: '中国',
  852: '香港',
  853: '澳门',
  886: '台湾',
  81: '日本',
  82: '韩国',
  65: '新加坡',
  84: '越南',
  60: '马来西亚',
  62: '印尼',
  63: '菲律宾',
  66: '泰国',
  1: '美国',
  44: '英国',
  33: '法国',
  49: '德国',
};
const PHONE_CODE_JP = {
  86: '中国',
  852: '香港',
  853: 'マカオ',
  886: '台湾',
  81: '日本',
  82: '韓国',
  65: 'シンガポール',
  84: 'ベトナム',
  60: 'マレーシア',
  62: 'インドネシア',
  63: 'フィリピン',
  66: 'タイ',
  1: 'アメリカ合衆国/カナダ',
  44: '英国',
  33: 'フランス',
  49: 'ドイツ',
};
const PHONE_CODE_HK = {
  86: '中國大陸',
  852: '香港',
  853: '澳門',
  886: '臺灣',
  81: '日本',
  82: '韓國',
  65: '新加坡',
  84: '越南',
  60: '馬來西亞',
  62: '印尼',
  63: '菲律賓',
  66: '泰國',
  1: '美國/加拿大',
  44: '英國',
  33: '法國',
  49: '德國',
};
const PHONE_CODE_EN = {
  86: 'China',
  852: 'Hong Kong',
  853: 'Macau',
  886: 'Taiwan',
  81: 'Japan',
  82: 'Korea',
  65: 'Singapore',
  84: 'Viet Nam',
  60: 'Malaysia',
  62: 'Indonesia',
  63: 'Philippines',
  66: 'Thailand',
  1: 'US/Canada',
  44: 'British',
  33: 'France',
  49: 'Germany',
};
const PHONE_CODE_KO = {
  86: '중국',
  852: '홍콩',
  853: '마카오',
  886: '대만',
  81: '일본',
  82: '대한민국',
  65: '싱가포르',
  84: '베트남',
  60: '말레이시아',
  62: '인도네시아',
  63: '필리핀',
  66: '태국',
  1: '미국/캐나다',
  44: '영국',
  33: '프랑스',
  49: '독일',
};
const PHONE_CODE_ALL = [PHONE_CODE_CN, PHONE_CODE_JP, PHONE_CODE_HK, PHONE_CODE_EN, PHONE_CODE_EN];

/**
 * 多语言星期
 */
const WEEK_DAY_CN = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
const WEEK_DAY_JP = ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日'];
const WEEK_DAY_HK = ['週日', '週一', '週二', '週三', '週四', '週五', '週六'];
const WEEK_DAY_EN = ['Sun', 'Mon', 'Tues', 'Wed', 'Thur', 'Fri', 'Sat'];
const WEEK_DAY_KO = ['일', '월', '화', '수', '목', '금', '토'];
const WEEK_DAY_ALL = [WEEK_DAY_CN, WEEK_DAY_JP, WEEK_DAY_HK, WEEK_DAY_EN, WEEK_DAY_KO];

module.exports = {
  baigolfHost:'https://www.baigolf.com/',
  domain:  process.env.WEB_HOST,
  userData: {
    is_login: false,
    user_name: ''
  },
  userWallet: { // 獲取用戶個人資產
    bcc: {
      is_open_up: false,
      is_overdue: true,
      balance: 0,
    }
  },
  areaCode: PHONE_CODE_ALL,
  routerName: '',
  weekDay: WEEK_DAY_ALL,

  rooms: 1,     // 房间数
  adults: 1,    // 成人数
  children: 0,  // 儿童数
  ages: '',     // 儿童年龄
};



// WEBPACK FOOTER //
// ./src/store/state.js